import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAuthStore } from 'src/entities/user/store/useAuthStore';
import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

interface PostQuestionFilesPayload {
  body: any;
  productId: string;
  stageId: string;
  questionId: number;
}

const postQuestionFile = async (
  payload: PostQuestionFilesPayload
): Promise<any> => {
  try {
    const { body, productId, stageId, questionId } = payload;

    const { data } = await apiService.post<any>(
      `/products/${productId}/${stageId}/questions/${questionId}/files/`,
      body,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export const useQuestionFiles = () => {
  const queryClient = useQueryClient();
  const id = useAuthStore((state) => state.user?.id);

  return useMutation({
    mutationFn: async (payload: PostQuestionFilesPayload) => {
      return await postQuestionFile(payload);
    },
    onSuccess: async (_data, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['product-updates', id, variables.productId]
        }),
        queryClient.invalidateQueries({
          queryKey: ['product', variables.productId]
        })
      ]);
    }
  });
};
